<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ this.patient_name }} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="pb-1">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting Readmissions details.</v-alert>
          </v-col>
        </v-row>

        <v-row v-else-if="this.loading == false">
          <v-card-text>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table
            :loading="load"
            :headers="headers"
            :items="requestArray"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, -1],
            }"
            :items-per-page="10"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            show-expand
            item-key="_id"
            loading-text="Loading data..."
            class="elevation-0 rounded-0"
            style="width: 100%"
          >
            <template v-slot:item.AMOUNT="{ item }">
              {{ '$' + item.AMOUNT.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="px-0">
                <SpecCodes :insurance="insurance" :claimID="item._id" />
              </td>
            </template>
          </v-data-table>
        </v-row>
        <v-row v-else>
          <v-col class="text-center">
            <v-progress-circular
              indeterminate
              class="mt-5 mb-4"
              color="secondary"
              :size="50"
              :width="3"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SpecCodes from './SpecCodes.vue';
import axios from 'axios';

export default {
  name: 'readmissionsModal',
  components: {
    SpecCodes,
  },
  props: [
    'value',
    'readmissions',
    'patient_name',
    'insurance',
    'specialty',
    'startDate',
    'endDate',
    'groups',
    'providers',
    'locations',
    'readmissionsArray',
  ],
  data() {
    return {
      singleExpand: true,
      expanded: [],
      search: '',
      load: false,
      headers: [],
      dialog: false,
      loading: true,
      requestError: false,
      requestArray: [],
    };
  },
  methods: {
    async setReadmissions() {
      this.getHeaders();
      this.loading = true;
      const provNums = this.providers;
      let providers = [];
      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      const locs = this.locations;
      let locations = [];
      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }
      const url = `api/modal/readmits/${this.readmissionsArray}/groups=${this.groups}/providers=${providers}/locations=${locations}/${this.insurance}/${this.startDate}/${this.endDate}`;
      axios
        .get(url)
        .then((response) => {
          this.requestArray = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.requestError = true;
          this.loading = false;
        });
    },
    async getHeaders() {
      if (this.specialty) {
        this.headers = [
          { text: 'Claim ID', value: '_id' },
          { text: 'Patient Name', value: 'MEMBER_NAME' },
          { text: 'Servicer Name', value: 'SERVICER_NAME' },
          { text: 'Start Date', value: 'START_DATE' },
          { text: 'End Date', value: 'END_DATE' },
          { text: 'Amount', value: 'AMOUNT' },
        ];
      } else {
        this.headers = [
          { text: 'Claim ID', value: '_id' },
          { text: 'Servicer Name', value: 'SERVICER_NAME' },
          { text: 'Start Date', value: 'START_DATE' },
          { text: 'End Date', value: 'END_DATE' },
          { text: 'Amount', value: 'AMOUNT' },
        ];
      }
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async readmissionsArray() {
      this.setReadmissions();
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
